import { Restricted } from '@procureai/permissions-ui';

import { ThreadVariant } from '../../Cockpit.types';
import { useCockpitContext } from '../CockpitContextProvider/CockpitContextProvider.hook';
import { conversationLayoutClasses } from '@/legacy/components/ConversationLayout/ConversationLayout.styled';
import { useFrontdeskAssistant } from '@/legacy/hooks/useFrontdeskAssistant/useFrontdeskAssistant';
import { FeatureFlag } from '~/common/types';
import { Disclaimer } from '~/components/ConversationInput/components/Disclaimer/Disclaimer';
import { ConversationInput } from '~/components/ConversationInput/ConversationInput';
import { ConversationLayout } from '~/components/ConversationLayout/ConversationLayout';
import { ToolSelection } from '~/routes/IntakeCreate/components/ToolSelection/ToolSelection';
import { useIntakeCreate } from '~/routes/IntakeCreate/IntakeCreate.hook';

export const CockpitCreate = () => {
  const { openThread } = useCockpitContext();
  const agentId = useFrontdeskAssistant();

  const threadCallback = (threadId: string, initialMessage?: string) => {
    openThread(threadId, ThreadVariant.CONVERSATION, initialMessage);
  };
  const formCallback = (chatSessionId: string) => {
    openThread(chatSessionId, ThreadVariant.GUIDED);
  };

  const { onClick, onClickNewThread: onNewThread } = useIntakeCreate({
    formCallback,
    threadCallback,
  });

  return (
    <ConversationLayout
      sx={{
        [`& .${conversationLayoutClasses.conversationContainer}, & .${conversationLayoutClasses.inputContainer} > *`]: {
          maxWidth: {
            xl: 1280,
          },
        },
        [`& .${conversationLayoutClasses.inputContainer}`]: {
          background: `linear-gradient(0deg, #FAFAFA, 95%, transparent)`,
        },
      }}
      input={
        <Restricted needs={{ feature: FeatureFlag.SHOW_AGENT_FRONTDESK }}>
          <ConversationInput
            onSubmit={(args) => {
              // create a new thread with the general frontdesk agent
              // NOTE: we currently do not pass files yet (from the initial message)
              onNewThread(agentId, args.text);
            }}
          />
        </Restricted>
      }
      disclaimer={<Disclaimer />} // No disclaimer in CockpitCreate
    >
      <ToolSelection onClick={onClick} onClickNewThread={onNewThread} />
    </ConversationLayout>
  );
};
